// extracted by mini-css-extract-plugin
export default {"dashboardLayout":"DashboardLayout_dashboardLayout__XinkU","mainContent":"DashboardLayout_mainContent__H8-8P"};